// export const API_URL = "https://instaverse-backend.up.railway.app/api/v1";
export const API_URL = "https://instaverse-backend-1.onrender.com/api/v1";

export const GUEST_USER_PASSWORD = "12345678";
export const COMMENT_LIKE = "commentLike";
export const REPLY_LIKE = "replyLike";
export const LIKE = "like";

export const avatarUrls = [
  "https://res.cloudinary.com/umeshcloud/image/upload/v1711019265/instaverse%20avatar%27s/bjvpn1wtyvl7jgpntmcg.jpg",
  "https://res.cloudinary.com/umeshcloud/image/upload/v1711019272/instaverse%20avatar%27s/bzma7fezh7sqds4z6sju.jpg",
  "https://res.cloudinary.com/umeshcloud/image/upload/v1711019305/instaverse%20avatar%27s/um8coeh8bf8ofnxwszcp.jpg",
  "https://res.cloudinary.com/umeshcloud/image/upload/v1711019317/instaverse%20avatar%27s/vxeajgdidzgfyvxvgqab.jpg",
  "https://res.cloudinary.com/umeshcloud/image/upload/v1711019327/instaverse%20avatar%27s/moaw5kvjyczh7hqaauru.jpg",
  "https://res.cloudinary.com/umeshcloud/image/upload/v1711019337/instaverse%20avatar%27s/jtgj7mbi3j2dmnfssgjc.jpg",
  "https://res.cloudinary.com/umeshcloud/image/upload/v1711019348/instaverse%20avatar%27s/dupzprmfkpti3ysaryhm.jpg",
  "https://res.cloudinary.com/umeshcloud/image/upload/v1711019361/instaverse%20avatar%27s/tndxmmaostsupscgptmo.jpg",
  "https://res.cloudinary.com/umeshcloud/image/upload/v1711019366/instaverse%20avatar%27s/girgucnxt6efnvdye4zd.jpg",
  "https://res.cloudinary.com/umeshcloud/image/upload/v1711019418/instaverse%20avatar%27s/yqvjihjfleu1qs4chito.jpg",
  "https://res.cloudinary.com/umeshcloud/image/upload/v1711019450/instaverse%20avatar%27s/upcyhczye2yuvjrjxdqn.jpg",
  "https://res.cloudinary.com/umeshcloud/image/upload/v1711019465/instaverse%20avatar%27s/rgbzamr33sjw6tw0hzan.jpg",
];
